import React from 'react';
import '../styles/header.css';

interface HeaderProps {
  activeSource: 'arxiv' | 'crossref';
  onSourceChange: (source: 'arxiv' | 'crossref') => void;
}

export const Header: React.FC<HeaderProps> = ({ activeSource, onSourceChange }) => {
  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <h1>📚 Research Blog</h1>
      </div>
      <div className="nav-links">
        <button
          className={`nav-item ${activeSource === 'arxiv' ? 'active' : ''}`}
          onClick={() => onSourceChange('arxiv')}
        >
          Arxiv Search
        </button>
        <button
          className={`nav-item ${activeSource === 'crossref' ? 'active' : ''}`}
          onClick={() => onSourceChange('crossref')}
        >
          Cross Ref Search
        </button>
      </div>
    </nav>
  );
};